import React from 'react';

interface SectionHeadingProps {
  caption: string;
  title: React.ReactNode;
  description?: React.ReactNode;
  textColor?: 'light' | 'dark';
  className?: string;
}

export const SectionHeading: React.FC<SectionHeadingProps> = ({
  caption,
  title,
  description,
  textColor = 'dark',
  className = '',
}) => {
  const captionColor = textColor === 'light' ? 'text-blue-200' : 'text-gray-600';
  const titleColor = textColor === 'light' ? 'text-white' : 'text-dark-900';
  const descriptionColor = textColor === 'light' ? 'text-blue-100' : 'text-dark-700';

  return (
    <div className={`section_header mb-16 ${className}`}>
      <h3 className={`text-base font-mono ${captionColor} uppercase tracking-wider mb-3`}>
        {caption}
      </h3>
      <h2 className={`heading-style-h2 text-4xl sm:text-5xl font-normal mb-6 leading-relaxed ${titleColor}`}>
        {title}
      </h2>
      {description && (
        <p className={`text-lg sm:text-xl ${descriptionColor} leading-relaxed`}>
          {description}
        </p>
      )}
    </div>
  );
};
